/**
 * Calgary condo research portal entitlement — must match firestore.rules / storage.rules.
 * Admin Contacts "− RE" sets services to include "realEstate"; legacy accounts may only set realEstatePortalAccess.
 */

function safeStr(value) {
  return String(value ?? "").trim();
}

export const MARK_BEATTIE_CONTACT_EMAIL = "mark@markbeattie.ca";
export const MARK_BEATTIE_CONTACT_PHONE = "403-512-2106";

export function hasRealEstatePortalEntitlement(profile) {
  if (!profile || typeof profile !== "object") return false;
  if (profile.realEstatePortalAccess === true) return true;
  const services = profile.services;
  return Array.isArray(services) && services.includes("realEstate");
}
